import { useEffect } from "react";
import { EdicaoLayoutPersonalizadoHibrido } from "src/components/projetos/edicao/layouts/EdicaoLayoutPersonalizadoHibrido";
import { ProjetosFormInicialPersonalizadoHibrido } from "src/components/projetos/personalizados_hibrido/containers/Formulario/FormInicial";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto personalizado híbrido";

export const ProjetosFormInicialPersonalizadoHibridoEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayoutPersonalizadoHibrido>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialPersonalizadoHibrido />
          </div>
        </div>
      </div>
    </EdicaoLayoutPersonalizadoHibrido>
  );
};
